import React, { useEffect, useState } from "react";
import LocalStructuresTable from "./components/LocalStructuresTable";
import Create from "./modals/Create";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";

function LocalStructures(props) {
  const [localStructures, setLocalStructures] = useState([]);
  const [chooseLocalStructureId, setChooseLocalStructureId] = useState(
    undefined
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteLocalStructuresIds, setDeleteLocalStructuresIds] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [localStructuresData, setLocalStructuresData] = useState([]);

  const onLocalStructures = () => {
    setIsLoading(false);
    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP`)
      .then(({ data }) => {
        setIsLoading(false);
        setLocalStructures(data);
        setIsError(false);
      })
      .catch(() => {
        setIsLoading(false);
        setLocalStructures([]);
        setIsError(true);
      });
  };

  const onLocalStructuresData = (chooseLocalStructureId) => {
    setIsLoading(false);

    if (
      localStructuresData.length === 0 &&
      chooseLocalStructureId !== undefined
    ) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}structure/select?id=${chooseLocalStructureId}`
        )
        .then((res) => {
          setIsLoading(false);
          setLocalStructuresData([...localStructuresData, ...res.data]);
        });
    }

    const a = localStructuresData.some(
      (e) => e.parentId === chooseLocalStructureId
    );
    if (!a && chooseLocalStructureId !== undefined) {
      setIsLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}structure/select?id=${chooseLocalStructureId}`
        )
        .then((res) => {
          setIsLoading(false);
          setLocalStructuresData([...localStructuresData, ...res.data]);
        });
    }

    if (a === true) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onLocalStructuresData(chooseLocalStructureId);
    }, 500);
    return () => clearTimeout(timer);
  }, [chooseLocalStructureId]);

  useEffect(() => {
    onLocalStructures();
  }, []);

  const [structureId, setStructureId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select`)
      .then((res) => {
        const structureId = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
        setStructureId(structureId);
      });
  }, []);

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Strukturlar</h1>
      </div>
      <Divider className="w-100" />
      <LocalStructuresTable
        localStructures={localStructures}
        isLoading={isLoading}
        isError={isError}
        setChooseLocalStructureId={setChooseLocalStructureId}
        setShowCreate={setShowCreate}
        setDeleteLocalStructuresIds={setDeleteLocalStructuresIds}
        deleteLocalStructuresIds={deleteLocalStructuresIds}
        setIsLoading={setIsLoading}
      />

      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onLocalStructures={onLocalStructures}
          structureId={structureId}
        />
      )}
    </div>
  );
}

export default LocalStructures;
